module.exports = __webpack_public_path__ + "static/banner-cd39370e2df3af51f0d892106a27f94c.jpg";